import React from "react";
import { useHistory } from "react-router-dom";
import LikesGivenCtr from "../../../../../controller/community-ctr/activity-user/likes-given";
import baseUrl from "../../../../../service/constant";
import { fileUrl } from "../../../../../utils";
import { url } from "../../../../../service/constant";

const LikesGiven = (props: any) => {
  const history = useHistory();
  const providerLikesGiven = { ...LikesGivenCtr(props?.userId) };
  return (
    <>
      <h2 className="title">Likes given</h2>
      <ul className="separateElement">
        {providerLikesGiven?.likesGiven &&
          providerLikesGiven?.likesGiven?.map((like: any, index: number) => (
            <li key={index}>
              <div className="leftItem itemAuthor">
                <div className="imageAffiliatedcompany empty">
                  <img
                    className="imageAffiliatedcompany"
                    src={fileUrl(like?.profil_picture)}
                  />
                </div>
                <div className="infoAffiliated">
                  <h3 onClick={()=> history.push(url.community.activity.front_user_activity + like.user_id)} className="title">{like?.name}</h3>
                  <div className="post">{like?.job_title}</div>
                </div>
              </div>
              <div className="rightItem likeContent">
                <span className="icon-like-full"></span>
                {like?.nbre_likes}
              </div>
            </li>
          ))}

        <li className="linkForLi">
          <a
            className="viewAll"
            onClick={providerLikesGiven?.goToLikeGivenViewAll}
          >
            View all
          </a>
        </li>
      </ul>
    </>
  );
};

export default LikesGiven;
